export default __webpack_public_path__ + "static/media/ic_zones.5b857911.svg";